module.exports = __webpack_public_path__ + "static/media/bell-cowbell1.43ae767a.aac";